import { SET_STATISTICS } from '../types'

const reducer = (state, action) => {
  switch (action.type) {
    case SET_STATISTICS:
      return {
        ...state,
        statistics: action.payload,
        statisticsLoaded: true,
      }
    default:
      return state
  }
}

export default reducer
